import { MenuItem } from '@mui/material'
import { FormField } from 'global/components/Form'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { faixaColaborador } from 'service/api'

interface Props {
    limiteFuncionarios?: number
    disabled?: boolean
    required?: boolean
}

export function SelectColaboradores({
    disabled,
    required,
    limiteFuncionarios: limiteDefault,
}: Props) {
    const { setValue, watch } = useFormContext()
    const [data, setData] = useState<number[]>([])

    useEffect(() => {
        if (!data.length)
            faixaColaborador
                .get()
                .then(res => setData(res ?? []))
                .catch(() => setData([]))
    }, [data])

    const faixa = watch('limiteFuncionarios')

    useEffect(() => {
        if (!faixa && data?.length && limiteDefault)
            setValue('limiteFuncionarios', limiteDefault)
    }, [data])

    if (!data?.length) {
        return (
            <FormField
                name="limiteFuncionarios"
                label="Faixa de Colaboradores"
                disabled
            />
        )
    }

    return (
        <FormField
            select
            name="limiteFuncionarios"
            label="Faixa de Colaboradores"
            disabled={disabled}
            required={required}
        >
            {data
                .sort((a, b) => a - b)
                .map((limite, id) => {
                    return (
                        <MenuItem key={id} value={limite}>
                            até {limite}
                        </MenuItem>
                    )
                })}
            {!!faixa && !data.includes(faixa) && (
                <MenuItem value={faixa}>Especial (até {faixa})</MenuItem>
            )}
        </FormField>
    )
}
